import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const rootEl = document.getElementById("root")!;

try {
  createRoot(rootEl).render(<App />);
} catch (e) {
  // If React crashes on boot, show a recovery UI instead of frozen spinner
  rootEl.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#09090b;color:#fff;flex-direction:column;gap:16px;font-family:system-ui">
      <p style="font-size:18px">Unable to load. Please refresh the page.</p>
      <button onclick="location.reload()" style="padding:8px 20px;background:#3b82f6;color:white;border:none;border-radius:6px;cursor:pointer">Refresh</button>
    </div>
  `;
}
